(function(){
"use strict";
var $i=function(id){return document.getElementById(id)};
var currentStep=1;
var selectedLevel=null;
var currentProfile=null;
var cart=[];
var cartExpanded=false;
var scoredKites=[];
var scoredBoards=[];
var scoredBars=[];
var scoredPacks=[];
var conseilText='';
var imgCache={};
var stockCache={};
var variantCache={};

/* ============================================================
   PRODUCT CATALOGS
   ============================================================ */
var KITES=[
{title:"Aile + Barre F-One WTF!? 9m\u00B2 TBE",size:9,price:380,handle:"aile-barre-f-one-wtf-9m2-tres-bon-etat",vendor:"F-One",etat:"Tres Bon Etat",year:2023},
{title:"Aile Duotone Mono 9m\u00B2 2020",size:9,price:250,handle:"aile-barre-duotone-mono-9m2-2020-comme-neuf",vendor:"Duotone",etat:"Comme Neuf",year:2020},
{title:"Aile RRD Vision 12m\u00B2 2022",size:12,price:699,handle:"aile-rrd-vision-12m2-y27-2022-23",vendor:"RRD",etat:"Comme Neuf",year:2022},
{title:"Cabrinha Moto 14m\u00B2 2022",size:14,price:639,handle:"cabrinha-moto-14m2-2022-bon-etat",vendor:"Cabrinha",etat:"Tres Bon Etat",year:2022},
{title:"Cabrinha Switchblade 12m\u00B2 2023",size:12,price:589,handle:"import-kite-final-v112",vendor:"Cabrinha",etat:"Tres Bon Etat",year:2023},
{title:"Cabrinha Switchblade 7m\u00B2 2023",size:7,price:450,handle:"import-kite-final-v35",vendor:"Cabrinha",etat:"Bon Etat",year:2023},
{title:"Core GTS 6 9m\u00B2 2024",size:9,price:879,handle:"core-gts-6-9m2-2024",vendor:"Core",etat:"Tres Bon Etat",year:2024},
{title:"Core XR8 10m\u00B2 2024",size:10,price:1220,handle:"core-xr8-2024-10m2-2024-etat-comme-neuf",vendor:"Core",etat:"Tres Bon Etat",year:2024},
{title:"Duotone Evo 6m\u00B2 2024",size:6,price:713,handle:"duotone-evo-6m2-2024-tres-bon-etat",vendor:"Duotone",etat:"Bon Etat",year:2024},
{title:"Duotone Evo 7m\u00B2 2023",size:7,price:600,handle:"duotone-evo-7m2-2023-tres-bon-etat-repare-copie",vendor:"Duotone",etat:"Tres Bon Etat",year:2023},
{title:"Duotone Neo 11m\u00B2 2024",size:11,price:944,handle:"duotone-neo-11m2-2024-tres-bon-etat",vendor:"Duotone",etat:"Tres Bon Etat",year:2024},
{title:"Duotone Neo 7m\u00B2 2023",size:7,price:299,handle:"duotone-neo-7m2-2023-bon-etat",vendor:"Duotone",etat:"Bon Etat",year:2023},
{title:"Eleveight RS V7 14m\u00B2 2024",size:14,price:714,handle:"eleveight-rs-v7-14m2-2024",vendor:"Eleveight",etat:"Tres Bon Etat",year:2024},
{title:"Eleveight RS V8 10m\u00B2 2025",size:10,price:747,handle:"eleveight-rs-v8-10m2-comme-neuf-1",vendor:"Eleveight",etat:"Tres Bon Etat",year:2025},
{title:"Eleveight RS V8 12m\u00B2 TBE",size:12,price:1100,handle:"eleveight-rs-v8-12m2-tres-bon-etat-1",vendor:"Eleveight",etat:"Tres Bon Etat",year:2023},
{title:"Eleveight RS V8 8m\u00B2 2025",size:8,price:799,handle:"eleveight-rs-v8-8m2-neuf",vendor:"Eleveight",etat:"Tres Bon Etat",year:2025},
{title:"Eleveight RS V8 9m\u00B2 2025",size:9,price:750,handle:"eleveight-rs-v7-9m2-2024-bon-etat-copy",vendor:"Eleveight",etat:"Tres Bon Etat",year:2025},
{title:"Eleveight WS V6 5m\u00B2 2023",size:5,price:390,handle:"eleveight-ws-v6-6m2-2023",vendor:"Eleveight",etat:"Tres Bon Etat",year:2023},
{title:"F-One Bandit 10m\u00B2 2020",size:10,price:390,handle:"f-one-bandit-10m2-2020-tres-bon-etat",vendor:"F-One",etat:"Bon Etat",year:2020},
{title:"F-One Bandit 17 TEC 10m\u00B2 2025",size:10,price:890,handle:"f-one-bandit-17-tec-2025-neuf-copie-1",vendor:"F-One",etat:"Tres Bon Etat",year:2025},
{title:"F-One Bandit S3 8m\u00B2 2022",size:8,price:489,handle:"f-one-bandit-s3-8m2-2022-tres-bon-etat",vendor:"F-One",etat:"Tres Bon Etat",year:2022},
{title:"F-One Bandit S4 8m\u00B2 2024",size:8,price:849,handle:"f-one-bandit-s4-p-1",vendor:"F-One",etat:"Tres Bon Etat",year:2024},
{title:"F-One Bandit TEC 12m\u00B2 TBE",size:12,price:700,handle:"f-one-bandit-tec-12m2-tres-bon-etat",vendor:"F-One",etat:"Tres Bon Etat",year:2023},
{title:"F-One Breeze V4 11m\u00B2 2023",size:11,price:629,handle:"f-one-breeze-v4-11m2-2023-tres-bon-etat",vendor:"F-One",etat:"Tres Bon Etat",year:2023},
{title:"F-One Trigger V2 TEC 9m\u00B2 2025",size:9,price:1399,handle:"f-one-trigger-v2-tec-2025-comme-neuf",vendor:"F-One",etat:"Comme Neuf",year:2025},
{title:"F-One Bandit S2 5m\u00B2 2021",size:5,price:349,handle:"f-one-bandit-s2-2021-5m2-tres-bon-etat-copie",vendor:"F-One",etat:"Tres Bon Etat",year:2021}
];

var BOARDS_KITE=[
{title:"Duotone Select 132cm 2020",length:132,width:39,price:430,handle:"duotone-select-132cm-2020-tres-bon-etat",vendor:"Duotone",etat:"Tres Bon Etat",year:2020},
{title:"Eleveight Master C+ V8",length:138,width:42,price:889,handle:"eleveight-master-c-v8",vendor:"Eleveight",etat:"Neuf",year:2024},
{title:"Eleveight Master S V6",length:136,width:41,price:789,handle:"eleveight-process-v9-copie",vendor:"Eleveight",etat:"Neuf",year:2024},
{title:"Eleveight Master V9",length:140,width:42,price:789,handle:"eleveight-master-s-neuf-copie",vendor:"Eleveight",etat:"Neuf",year:2024},
{title:"Eleveight Process V10",length:139,width:42,price:589,handle:"eleveight-process-v10",vendor:"Eleveight",etat:"Neuf",year:2025},
{title:"F-One ONE 138cm 2025",length:138,width:41,price:490,handle:"f-one-one-138cm-2025-tres-bon-etat",vendor:"F-One",etat:"Tres Bon Etat",year:2025},
{title:"F-One One 140cm 2025 Complete",length:140,width:42,price:429,handle:"f-one-one-140cm-2025-neuve-complete",vendor:"F-One",etat:"Tres Bon Etat",year:2025},
{title:"F-One Trax 133cm 2024",length:133,width:40,price:349,handle:"f-one-trax-133cm-2024-bon-etat",vendor:"F-One",etat:"Bon Etat",year:2024},
{title:"F-One Trax 136cm 2024",length:136,width:41,price:455,handle:"f-one-trax-136cm-2024-tres-bon-etat",vendor:"F-One",etat:"Tres Bon Etat",year:2024},
{title:"F-One Trax HRD Carbon 137cm 2025",length:137,width:41,price:650,handle:"f-one-trax-hrd-135cm-2022-tres-bon-etat-copie",vendor:"F-One",etat:"Tres Bon Etat",year:2025},
{title:"Duotone Soleil 2025 Complete",length:140,width:42,price:749,handle:"f-one-one-140cm-2025-comme-neuf-complete-copie",vendor:"Duotone",etat:"Neuf",year:2025}
];

var BARS=[
{title:"Barre Naish ATB-55 TBE",barSize:"M",price:210,handle:"barre-naish-atb-55-2024-tres-bon-etat",vendor:"Naish",etat:"Tres Bon Etat",year:2024},
{title:"Barre Kite Attitude V4 Neuf",barSize:"M",price:349,handle:"barre-universelle-kite-attitude-v4-neuf",vendor:"Kite Attitude",etat:"Neuf",year:2024},
{title:"Barre Kite Attitude Totem Vario",barSize:"M",price:279,handle:"kite-attitude-totem-vario-2023-neuf",vendor:"Kite Attitude",etat:"Neuf",year:2023},
{title:"Barre Totem Vario Access+ CN",barSize:"M",price:229,handle:"barre-universelle-totem-vario-access-1",vendor:"Kite Attitude",etat:"Comme Neuf",year:2023},
{title:"Barre Totem Vario Pro",barSize:"M",price:359,handle:"barre-universelle-totem-vario-pro-model-neuf",vendor:"Kite Attitude",etat:"Neuf",year:2024},
{title:"Core Sensor 3 2024",barSize:"M",price:395,handle:"core-sensor-3-2024-etat-a-definir",vendor:"Core",etat:"Bon Etat",year:2024},
{title:"Core Sensor Pro 3 S 2023",barSize:"S",price:479,handle:"core-sensor-pro-3-2023",vendor:"Core",etat:"Bon Etat",year:2023},
{title:"Duotone Trust 22m 2023 TBE",barSize:"M",price:349,handle:"duotone-trust-22m-2023-bon-etat",vendor:"Duotone",etat:"Tres Bon Etat",year:2023},
{title:"Duotone Trust 24m 2022",barSize:"L",price:249,handle:"duotone-trust-24m-2022-bon-etat-3",vendor:"Duotone",etat:"Bon Etat",year:2022},
{title:"Duotone Trust Bar 2025 Neuf",barSize:"M",price:619,handle:"duotone-trust-bar-2025-neuf",vendor:"Duotone",etat:"Neuf",year:2025},
{title:"Eleveight CS Auto L 2024 TBE",barSize:"L",price:422,handle:"eleveight-cs-auto-l-2024-tres-bon-etat-copie",vendor:"Eleveight",etat:"Tres Bon Etat",year:2024},
{title:"Eleveight CS Auto V2 Neuf",barSize:"M",price:649,handle:"eleveight-cs-auto-v2-neuf",vendor:"Eleveight",etat:"Neuf",year:2024},
{title:"Eleveight CS+ Vary V4 S 2024 CN",barSize:"S",price:450,handle:"eleveight-cs-vary-v4-s-2024-neuf",vendor:"Eleveight",etat:"Comme Neuf",year:2024},
{title:"F-One Lynx Bar SK99 2025 CN",barSize:"M",price:450,handle:"f-one-lynx-bar-52x45cm-2024-tres-bon-etat-copie-1",vendor:"F-One",etat:"Comme Neuf",year:2025},
{title:"F-One Lynx Bar SK99 2025 TBE",barSize:"M",price:420,handle:"f-one-lynx-bar-52x45cm-sk99-2025-tres-bon-etat-copie",vendor:"F-One",etat:"Tres Bon Etat",year:2025}
];

/* ============================================================
   LOOKUP TABLE KITE — basee sur le tableau The Ridery
   Gabarits: 30-38, 40-48, 50-58, 60-68, 70-78, 80-88, 90-98, 100-108, 110+
   ============================================================ */
/* ============================================================
   NOUVELLE LOGIQUE QUIVER — 3 ailes par gabarit (leger / medium / fort)
   Vent leger 10-15kts, medium 15-28kts, fort 28+kts
   Jamais en dessous de 5m2, jamais vent fort pour un debutant
   Le niveau ne change PAS la taille d'aile (on ne sous-toile pas un expert)
   Le niveau joue uniquement sur la planche (taille legerement reduite)
   Barre : toujours universelle Kite Attitude
   ============================================================ */
var KITE_SPECS={
  'tres_leger':{kite_light:'10m\u00B2',kite_medium:'7m\u00B2',kite_strong:'5m\u00B2',board:'133x40 / 134x40',label:'Tres leger / Femmes'},
  'leger':{kite_light:'11m\u00B2',kite_medium:'8m\u00B2',kite_strong:'6m\u00B2',board:'135x39 / 136x41',label:'Leger'},
  'standard':{kite_light:'12m\u00B2',kite_medium:'9m\u00B2',kite_strong:'7m\u00B2',board:'136x41 / 137x42',label:'Standard'},
  'lourd':{kite_light:'13m\u00B2',kite_medium:'10m\u00B2',kite_strong:'8m\u00B2',board:'138x41 / 139x42',label:'Lourd'},
  'tres_lourd':{kite_light:'14m\u00B2',kite_medium:'11m\u00B2',kite_strong:'9m\u00B2',board:'140x43 / 144x43',label:'Tres lourd'}
};

function getWeightCat(poids){
  if(poids<60)return'tres_leger';
  if(poids<70)return'leger';
  if(poids<=90)return'standard';
  if(poids<=105)return'lourd';
  return'tres_lourd';
}

function getKiteSpecs(poids){
  var cat=getWeightCat(poids);
  return KITE_SPECS[cat];
}

/* ============================================================
   NAVIGATION
   ============================================================ */
function showStep(n){
  document.querySelectorAll('.sim-kite .sk-step').forEach(function(s){s.classList.remove('sk-active')});
  var target=$i('sk-step-'+n);
  if(target)target.classList.add('sk-active');
  currentStep=n;
  var pcts={1:50,2:100};
  var pf=$i('sk-progress-fill');
  if(pf)pf.style.width=(pcts[n]||25)+'%';
  var pd=$i('sk-progress-dots');
  if(pd){
    var dots=pd.querySelectorAll('.sk-dot');
    dots.forEach(function(d,i){
      d.classList.remove('sk-active','sk-done');
      if(i+1===n)d.classList.add('sk-active');
      else if(i+1<n)d.classList.add('sk-done');
    });
  }
  var container=document.querySelector('.sim-kite');
  if(container){var rect=container.getBoundingClientRect();if(rect.top<0)window.scrollBy({top:rect.top-20,behavior:'smooth'})}
}

/* Level cards */
var levelOpts=$i('sk-level-options');
if(levelOpts){
  var levelCards=levelOpts.querySelectorAll('.sk-option-card');
  levelCards.forEach(function(card){
    card.addEventListener('click',function(){
      levelCards.forEach(function(c){c.classList.remove('selected')});
      card.classList.add('selected');
      selectedLevel=card.getAttribute('data-value');
    });
  });
}

/* Spot "Autre" toggle */
var spotSel=$i('sk-spot-select');
var autreWrap=$i('sk-autre-wrap');
if(spotSel&&autreWrap){
  spotSel.addEventListener('change',function(){
    autreWrap.style.display=this.value==='autre'?'block':'none';
  });
}

/* Autocomplete ville */
(function(){
  var input=$i('sk-autre-ville');
  var ac=$i('sk-autocomplete');
  if(!input||!ac)return;
  var timer;
  input.addEventListener('input',function(){
    clearTimeout(timer);
    var q=this.value.trim();
    if(q.length<2){ac.style.display='none';ac.innerHTML='';return}
    timer=setTimeout(function(){
      var xhr=new XMLHttpRequest();
      xhr.open('GET','https://geo.api.gouv.fr/communes?nom='+encodeURIComponent(q)+'&fields=nom,departement&limit=6',true);
      xhr.onload=function(){
        try{
          var data=JSON.parse(xhr.responseText);
          if(!data.length){ac.style.display='none';return}
          ac.innerHTML='';
          data.forEach(function(c){
            var div=document.createElement('div');
            div.style.cssText='padding:10px 14px;cursor:pointer;font-size:.9em;border-bottom:1px solid #f0f0f0';
            div.textContent=c.nom+(c.departement?' ('+c.departement.code+')':'');
            div.addEventListener('click',function(){input.value=this.textContent;ac.style.display='none'});
            div.addEventListener('mouseover',function(){this.style.background='#fff7ed'});
            div.addEventListener('mouseout',function(){this.style.background='#fff'});
            ac.appendChild(div);
          });
          ac.style.display='block';
        }catch(e){ac.style.display='none'}
      };
      xhr.onerror=function(){ac.style.display='none'};
      xhr.send();
    },250);
  });
  document.addEventListener('click',function(e){if(!e.target.closest('#sk-autre-wrap'))ac.style.display='none'});
})();

/* Help tooltips */
document.querySelectorAll('.sim-kite .sk-help').forEach(function(el){
  var tip=document.createElement('span');
  tip.className='sk-tip';
  tip.textContent=el.getAttribute('data-tip');
  el.appendChild(tip);
  el.addEventListener('click',function(ev){
    ev.stopPropagation();
    document.querySelectorAll('.sim-kite .sk-help').forEach(function(h){h.classList.remove('sk-tip-open')});
    this.classList.toggle('sk-tip-open');
  });
});
document.addEventListener('click',function(){document.querySelectorAll('.sim-kite .sk-help').forEach(function(h){h.classList.remove('sk-tip-open')})});

/* ============================================================
   SCORING
   ============================================================ */

function normalizeEtat(e){
  if(!e)return'autre';
  var l=e.toLowerCase().replace(/[e\u00E9\u00E8]/g,'e').replace(/[\u00E0a]/g,'a').replace(/[^\w\s]/g,'');
  if(l.indexOf('neuf')===0&&l.length<6)return'Neuf';
  if(l.indexOf('comme neuf')>=0)return'Comme Neuf';
  if(l.indexOf('tres bon')>=0)return'TBE';
  if(l.indexOf('bon etat repare')>=0)return'Repare';
  if(l.indexOf('bon etat')>=0)return'BE';
  if(l.indexOf('correct')>=0)return'Correct';
  if(l.indexOf('repare')>=0)return'Repare';
  return'TBE';
}

function parseKiteSizeRange(str){
  /* Parses "9-10m\u00B2" or "\u226515m\u00B2" into [lo, hi] */
  if(!str)return null;
  var m=str.match(/([\d.]+)/g);
  if(!m||m.length===0)return null;
  if(m.length===1)return{lo:parseFloat(m[0]),hi:parseFloat(m[0])};
  return{lo:parseFloat(m[0]),hi:parseFloat(m[1])};
}

function parseBoardDims(str){
  /* Parses "136x41" into {length, width} */
  if(!str)return null;
  var m=str.match(/(\d+)\s*x\s*(\d+)/);
  if(!m)return null;
  return{length:parseInt(m[1]),width:parseInt(m[2])};
}

function scoreSize_kite(product,profile){
  /* Ne jamais recommander du 4m2 */
  if(product.size&&product.size<=4.5)return 0;
  var specs=getKiteSpecs(profile.poids);
  /* Le quiver couvre 3 tailles : kite_light, kite_medium, kite_strong.
     Un produit colle bien au quiver si sa taille est proche d'une des 3. */
  var sizes=[];
  ['kite_light','kite_medium','kite_strong'].forEach(function(k){
    var m=(specs[k]||'').match(/([\d.]+)/);
    if(m)sizes.push(parseFloat(m[1]));
  });
  if(sizes.length===0)return 10;
  var minDiff=Infinity;
  sizes.forEach(function(s){var d=Math.abs(product.size-s);if(d<minDiff)minDiff=d});
  if(minDiff<=0.5)return 30;
  if(minDiff<=1)return 25;
  if(minDiff<=1.5)return 18;
  if(minDiff<=2)return 10;
  return 0;
}

function scoreSize_board_kite(product,profile){
  var specs=getKiteSpecs(profile.poids);
  /* Parse recommended board from specs, e.g. "136x41 / 137x42" */
  var boardStr=specs.board||'';
  var parts=boardStr.split('/');
  var dims=[];
  parts.forEach(function(p){
    var d=parseBoardDims(p.trim());
    if(d)dims.push(d);
  });
  if(dims.length===0)return 15;
  /* Average recommended length & width */
  var avgLen=dims.reduce(function(s,d){return s+d.length},0)/dims.length;
  var avgWid=dims.reduce(function(s,d){return s+d.width},0)/dims.length;
  var diffLen=Math.abs(product.length-avgLen);
  var diffWid=Math.abs(product.width-avgWid);
  var lenScore=0;
  if(diffLen<=2)lenScore=20;else if(diffLen<=4)lenScore=15;else if(diffLen<=6)lenScore=10;else if(diffLen<=10)lenScore=5;
  var widScore=0;
  if(diffWid<=1)widScore=10;else if(diffWid<=2)widScore=7;else if(diffWid<=3)widScore=4;else if(diffWid<=5)widScore=2;
  return lenScore+widScore;
}

function scoreSize_bar(product,profile){
  /* On ne recommande plus de taille de barre (trop variable selon marques).
     On privilegie systematiquement Kite Attitude (barres universelles). */
  var v=(product.vendor||'').toLowerCase();
  if(v.indexOf('kite attitude')>=0)return 30;
  if(v.indexOf('totem')>=0)return 28;
  return 8;
}

function scoreBudget(product,profile){
  var caps={petit:500,moyen:900,confort:1400,premium:Infinity};
  var cap=caps[profile.budget]||1000;
  var price=product.price;
  if(price<=cap)return 25;
  var over=(price-cap)/cap;
  if(over<=0.2)return 15;
  if(over<=0.4)return 8;
  return -999;
}

function scoreBrandStyle(product,profile){
  var v=product.vendor||'';
  var score=10;
  if(selectedLevel==='debutant'){
    if(['Cabrinha','Slingshot','Naish'].indexOf(v)>=0)score=20;
    else if(['Duotone','F-One','Ozone'].indexOf(v)>=0)score=15;
    else if(['Core','North','Eleveight'].indexOf(v)>=0)score=12;
  }else if(selectedLevel==='intermediaire'){
    if(['Duotone','Core','North'].indexOf(v)>=0)score=20;
    else if(['F-One','Ozone','Cabrinha'].indexOf(v)>=0)score=18;
    else if(['Eleveight','Naish','Slingshot'].indexOf(v)>=0)score=15;
  }else{
    if(['Core','North','Duotone'].indexOf(v)>=0)score=20;
    else if(['F-One','Ozone','Eleveight'].indexOf(v)>=0)score=18;
    else if(['Cabrinha','Naish','Slingshot'].indexOf(v)>=0)score=15;
  }
  return score;
}

function scoreCondition(product,profile){
  var matrix={
    petit:{Neuf:5,'Comme Neuf':10,TBE:13,BE:15,Repare:12,Correct:8},
    moyen:{Neuf:10,'Comme Neuf':13,TBE:15,BE:12,Repare:8,Correct:3},
    confort:{Neuf:13,'Comme Neuf':15,TBE:12,BE:8,Repare:3,Correct:0},
    premium:{Neuf:15,'Comme Neuf':12,TBE:8,BE:3,Repare:0,Correct:0}
  };
  var row=matrix[profile.budget]||matrix.moyen;
  return row[normalizeEtat(product.etat)]||5;
}

function scoreFreshness(product){
  var y=product.year||2022;
  if(y>=2026)return 10;if(y>=2025)return 9;if(y>=2024)return 7;if(y>=2023)return 5;if(y>=2022)return 3;if(y>=2021)return 1;return 0;
}

function generateReason(product,sizeScore,budgetScore,brandScore,condScore){
  var parts=[];
  if(sizeScore>=25)parts.push('Taille parfaite pour toi');
  else if(sizeScore>=18)parts.push('Taille adaptee');
  else if(sizeScore>=10)parts.push('Taille acceptable');
  else parts.push('Taille un peu eloignee');
  if(budgetScore>=25)parts.push('dans ton budget');
  else if(budgetScore>=15)parts.push('leger depassement budget');
  else parts.push('au-dessus de ton budget');
  if(brandScore>=20)parts.push(product.vendor+' reference');
  else if(brandScore>=15)parts.push(product.vendor+' solide');
  if(condScore>=13)parts.push('super etat');
  else if(condScore>=10)parts.push('bon rapport qualite/prix');
  return parts.slice(0,3).join(', ');
}

function scoreProducts(products,profile,category){
  var sizeFn=category==='kite'?scoreSize_kite:category==='board_kite'?scoreSize_board_kite:scoreSize_bar;
  var scored=products.map(function(p){
    var s1=sizeFn(p,profile);
    if(s1===0)return null;
    var s2=scoreBudget(p,profile);
    if(s2===-999)return null;
    var s3=scoreBrandStyle(p,profile);
    var s4=scoreCondition(p,profile);
    var s5=scoreFreshness(p);
    var total=s1+s2+s3+s4+s5;
    var reason=generateReason(p,s1,s2,s3,s4);
    return Object.assign({},p,{rawScore:total,reason:reason,category:category});
  }).filter(function(x){return x!==null&&x.rawScore>0}).sort(function(a,b){return b.rawScore-a.rawScore});
  if(scored.length===0)return scored;
  var best=scored[0].rawScore;
  return scored.map(function(p){
    var pct=Math.round((p.rawScore/best)*98);
    return Object.assign({},p,{score:Math.max(20,Math.min(99,pct))});
  });
}

/* ============================================================
   CONSEIL PERSO
   ============================================================ */
function getConseil(profile){
  var poids=profile.poids;
  var specs=getKiteSpecs(poids);
  var showStrong=(profile.level!=='debutant');
  var quiverParts=[];
  if(specs.kite_light)quiverParts.push(specs.kite_light+' (vent leger)');
  if(specs.kite_medium)quiverParts.push(specs.kite_medium+' (vent medium)');
  if(showStrong&&specs.kite_strong)quiverParts.push(specs.kite_strong+' (vent fort)');
  var quiverStr=quiverParts.join(' + ');

  var SPOT_VENT={
    marseille:{v:'le Mistral NW souffle entre 15 et 35 noeuds',s:'surtout de septembre a mai'},
    hyeres:{v:'le Mistral et les thermiques tournent a plein regime (15-30 noeuds)',s:"quasi toute l'annee"},
    montpellier:{v:'la Tramontane et le Marin balayent les etangs a 15-30 noeuds',s:"d'avril a octobre"},
    leucate:{v:'la Tramontane cartonne entre 18 et 35 noeuds quasi en continu',s:"toute l'annee"},
    nice:{v:"le vent d'Est donne des creneaux 12-25 noeuds",s:'principalement de septembre a mai'},
    biarritz:{v:'la houle Atlantique et le vent de terre offrent 15-25 noeuds',s:'de mai a octobre'},
    paris:{v:'le vent est plus light et rafaleux, autour de 10-18 noeuds',s:"surtout de mai a septembre"},
    bonifacio:{v:'le Libeccio dechaine 20-35 noeuds entre Corse et Sardaigne',s:"d'avril a octobre"},
    atlantique:{v:'le flux NW Atlantique souffle regulierement a 15-28 noeuds',s:"d'avril a octobre"},
    cote_opale:{v:"le vent d'ouest Atlantique souffle entre 12 et 25 noeuds, souvent rafaleux",s:"d'avril a octobre"},
    normandie:{v:'le NW Atlantique souffle entre 12 et 25 noeuds',s:"toute l'annee"},
    bretagne:{v:'le flux W/SW Atlantique souffle quasi quotidiennement a 15-28 noeuds',s:"toute l'annee"},
    baie_somme:{v:"le vent d'ouest Atlantique souffle entre 12 et 25 noeuds sur les estuaires",s:"d'avril a octobre"},
    autre:{v:'les conditions varient selon ton spot',s:'a preciser avec nous'}
  };
  var SPOT_PHRASE={
    marseille:"le Mistral c'est ton turbo ici \u2014 20-35 noeuds bien cales Nord-Ouest, ca souffle 100+ jours par an. Le Prado, la Pointe Rouge, les Goudes... t'as l'embarras du choix",
    montpellier:"l'etang de Thau, Palavas, Carnon \u2014 t'as des plans d'eau flat comme un miroir des que la Tramontane se leve. Conditions ideales pour progresser",
    nice:"sessions au lever du soleil avec l'eau turquoise et les Alpes en fond \u2014 le vent d'Est te donne des creneaux magiques",
    leucate:"la Tramontane c'est un ventilateur geant qui s'arrete jamais \u2014 t'es sur LE spot reference du Sud pour le kite",
    hyeres:"l'Almanarre c'est la Mecque du kite \u2014 flat cristallin le matin, clapot l'apres-midi, Mistral quasi quotidien en saison",
    biarritz:"la houle Atlantique + le vent de terre ca donne des conditions magiques. Anglet, la Barre, Hendaye...",
    paris:"on va pas se mentir, le vent est capricieux en IDF \u2014 mais quand ca envoie sur Jablines ou le lac de l'Ailette, ca vaut le coup",
    bonifacio:"le Libeccio entre Corse et Sardaigne c'est du vent de malade dans un decor irreal",
    atlantique:"la cote Atlantique c'est du vent et de la houle toute l'annee \u2014 des conditions dynamiques"
  };
  var DEPT_PHRASE={
    '13':"conditions Mistral comme a Marseille \u2014 du vent regulier et puissant",
    '83':"conditions Mistral comme a Marseille \u2014 du vent regulier et puissant",
    '06':"vent d'Est type Cote d'Azur \u2014 moins frequent mais sessions magnifiques",
    '34':"zone Tramontane comme Montpellier \u2014 plans d'eau flat et vent regulier",
    '30':"zone Tramontane comme Montpellier \u2014 plans d'eau flat et vent regulier",
    '11':"zone Leucate \u2014 la Tramontane c'est ton quotidien",
    '64':"cote Atlantique \u2014 houle + vent, conditions dynamiques",
    '40':"cote Atlantique \u2014 houle + vent, conditions dynamiques",
    '2A':"la Corse c'est du vent fort dans un decor de reve",
    '2B':"la Corse c'est du vent fort dans un decor de reve",
    '44':"zone La Baule \u2014 grande baie bien exposee NW",
    '33':"zone Bassin d'Arcachon \u2014 flat + thermique, ideal pour progresser",
    '75':"region parisienne \u2014 les plans d'eau existent mais faut guetter la meteo",
    '77':"region parisienne \u2014 les plans d'eau existent mais faut guetter la meteo",
    '78':"region parisienne \u2014 les plans d'eau existent mais faut guetter la meteo",
    '91':"region parisienne \u2014 les plans d'eau existent mais faut guetter la meteo",
    '92':"region parisienne \u2014 les plans d'eau existent mais faut guetter la meteo",
    '93':"region parisienne \u2014 les plans d'eau existent mais faut guetter la meteo",
    '94':"region parisienne \u2014 les plans d'eau existent mais faut guetter la meteo",
    '95':"region parisienne \u2014 les plans d'eau existent mais faut guetter la meteo",
    '29':"la Bretagne c'est un secret de rider \u2014 du vent quasi toute l'annee",
    '22':"la Bretagne c'est un secret de rider \u2014 du vent quasi toute l'annee",
    '56':"la Bretagne c'est un secret de rider \u2014 du vent quasi toute l'annee",
    '35':"la Bretagne c'est un secret de rider \u2014 du vent quasi toute l'annee",
    '17':"Vendee / Charente \u2014 vent d'ouest regulier, plans d'eau plats cote marais",
    '85':"Vendee / Charente \u2014 vent d'ouest regulier, plans d'eau plats cote marais"
  };

  var spot=profile.spot;
  var sv=SPOT_VENT[spot]||SPOT_VENT.autre;
  var spotPhrase;
  if(spot==='autre'){
    var ville=profile.autreVille||'';
    var dm=ville.match(/\((\d+[AB]?)\)/);
    if(dm&&DEPT_PHRASE[dm[1]]){
      spotPhrase="on connait les conditions par chez toi \u2014 "+DEPT_PHRASE[dm[1]];
      if('13,83'.indexOf(dm[1])>=0)sv=SPOT_VENT.marseille;
      else if(dm[1]==='06')sv=SPOT_VENT.nice;
      else if('34,30'.indexOf(dm[1])>=0)sv=SPOT_VENT.montpellier;
      else if(dm[1]==='11')sv=SPOT_VENT.leucate;
      else if('64,40'.indexOf(dm[1])>=0)sv=SPOT_VENT.biarritz;
      else if('2A,2B'.indexOf(dm[1])>=0)sv=SPOT_VENT.bonifacio;
      else if(dm[1]==='44'||dm[1]==='33')sv=SPOT_VENT.atlantique;
      else if('75,77,78,91,92,93,94,95'.indexOf(dm[1])>=0)sv=SPOT_VENT.paris;
    }else{
      spotPhrase="chaque spot a son caractere \u2014 dis-nous ou tu rides exactement et on te cale le setup parfait";
    }
  }else{
    spotPhrase=SPOT_PHRASE[spot]||"on adapte tout a ton spot";
  }

  var B=function(t){return'<b>'+t+'</b>'};
  var spotNames={marseille:'Marseille',hyeres:'Hyeres / Almanarre',montpellier:'Montpellier / Sete',leucate:'Leucate',nice:"Nice / Cote d'Azur",biarritz:'Biarritz',paris:'Paris / IDF',bonifacio:'Corse',atlantique:'la facade Atlantique',cote_opale:"la Cote d'Opale",normandie:'Normandie',bretagne:'Bretagne',baie_somme:'Baie de Somme',autre:'ton spot'};
  var spotName=spotNames[spot]||profile.autreVille||'ton spot';
  var spotLine='<div style="margin-bottom:12px;font-size:.95em;line-height:1.6">Sur <b>'+spotName+'</b>, '+sv.v+', '+sv.s+'.</div>';
  var sizeLine='<div style="margin-bottom:12px;font-size:.95em;line-height:1.6">Pour ton gabarit ('+specs.label.toLowerCase()+', '+poids+' kg), on te conseille de construire ton quiver avec '+B(quiverStr)+'. Pour la planche : '+B(specs.board.split('/')[0].trim()+' cm')+'. Pour la barre : '+B('une barre universelle Kite Attitude')+' — compatible avec toutes tes ailes.</div>';
  var conseil=spotLine+sizeLine+'<div style="margin-bottom:12px;padding:12px;background:#fff7ed;border-left:3px solid #e67e22;border-radius:4px;font-size:.9em;line-height:1.6">'+spotPhrase+'.</div>';

  if(profile.level==='debutant'){
    conseil+='<div style="margin-bottom:12px;font-size:.95em;line-height:1.6">Debutant, on te conseille de ne pas te precipiter sur le vent fort : commence par les ailes <b>'+B(specs.kite_light)+'</b> et <b>'+B(specs.kite_medium)+'</b> qui couvrent deja 80% des sessions. Privilegie du matos tolerant et stable, et '+B('loue avant d\'acheter')+' pour trouver ce qui te convient.</div>';
  }else if(profile.level==='intermediaire'){
    conseil+='<div style="margin-bottom:12px;font-size:.95em;line-height:1.6">A ton niveau, un quiver complet de 3 ailes te rend autonome sur toutes les conditions. Pense a la '+B('location')+' pour tester avant d\'investir sur du matos neuf.</div>';
  }else{
    conseil+='<div style="margin-bottom:12px;font-size:.95em;line-height:1.6">Avec ton niveau confirme, tu vises du matos performant et reactif sur les 3 tailles de ton quiver. On peut aussi '+B('racheter ton ancien matos')+' pour t\'aider a financer l\'upgrade.</div>';
  }

  /* CTA buttons */
  var matosBtn='<button onclick="openKiteMatosPopup()" style="display:block;width:100%;margin-top:10px;padding:14px;border:none;border-radius:12px;text-align:center;font-family:Staatliches,sans-serif;font-size:1.05em;letter-spacing:2px;cursor:pointer;background:linear-gradient(135deg,#d35400,#e67e22);color:#fff">DECOUVRIR DU MATOS FAIT POUR MOI</button>';
  var devisBtn='<button onclick="document.getElementById(\'sk-popup-devis\').style.display=\'flex\'" style="display:block;width:100%;margin-top:10px;padding:14px;border:none;border-radius:12px;text-align:center;font-family:Staatliches,sans-serif;font-size:1.05em;letter-spacing:2px;cursor:pointer;background:#fff;color:#d35400;border:2px solid #e67e22">RECEVOIR UN DEVIS PERSONNALISE</button>';
  var repriseBtn='<a href="https://theridery.com/pages/reprise-de-materiel" target="_blank" style="display:block;width:100%;margin-top:10px;padding:14px;border:none;border-radius:12px;text-align:center;font-family:Staatliches,sans-serif;font-size:1.05em;letter-spacing:2px;cursor:pointer;background:#e67e22;color:#fff;text-decoration:none">FAIRE REPRENDRE MON MATOS</a>';

  if(profile.level==='confirme'){
    conseil+=repriseBtn+matosBtn+devisBtn;
  }else{
    conseil+=matosBtn+devisBtn;
  }
  return conseil;
}

/* ============================================================
   STEP 1 → STEP 2 (results)
   ============================================================ */
var nextBtn=$i('sk-next-1');
if(nextBtn){
  nextBtn.addEventListener('click',function(){
    var poids=parseInt(($i('sk-poids')||{}).value);
    if(!poids||poids<25||poids>150){alert('Indique ton poids.');return}
    if(!selectedLevel){alert('Selectionne ton niveau.');return}
    var spotEl=$i('sk-spot-select');
    var spot=spotEl?spotEl.value:'';
    if(!spot){alert('Selectionne ton spot.');return}
    var budgetEl=$i('sk-budget-select');
    var budget=budgetEl?budgetEl.value:'';
    if(!budget){alert('Selectionne ton budget.');return}

    currentProfile={
      poids:poids,
      taille:parseInt(($i('sk-taille')||{}).value)||170,
      age:parseInt(($i('sk-age')||{}).value)||30,
      level:selectedLevel,
      spot:spot,
      budget:budget,
      autreVille:($i('sk-autre-ville')||{}).value||''
    };

    var specs=getKiteSpecs(poids);

    /* Debutant : jamais de vent fort */
    if(selectedLevel==='debutant'){
      specs=Object.assign({},specs,{kite_strong:null});
    }

    /* Score products */
    scoredKites=scoreProducts(KITES,currentProfile,'kite');
    scoredBoards=scoreProducts(BOARDS_KITE,currentProfile,'board_kite');
    scoredBars=scoreProducts(BARS,currentProfile,'bar');

    /* Summary bar — quiver complet + planche + barre universelle */
    var quiverVal=[specs.kite_light,specs.kite_medium,specs.kite_strong].filter(Boolean).join(' / ');
    var items=[
      {l:'Quiver',v:quiverVal},
      {l:'Planche',v:specs.board.split('/')[0].trim()+' cm'},
      {l:'Barre',v:'Universelle'}
    ];
    var sb=$i('sk-summary-bar');
    if(sb){
      sb.innerHTML=items.map(function(s){
        return'<div class="sk-summary-item"><div class="sk-si-label">'+s.l+'</div><div class="sk-si-value">'+s.v+'</div></div>';
      }).join('');
    }

    /* Wind grid : 3 plages — leger / medium / fort */
    var winds=[
      {label:'Vent leger (10-15 nds)',val:specs.kite_light,bg:'#d1fae5',color:'#065f46'},
      {label:'Vent medium (15-28 nds)',val:specs.kite_medium,bg:'#bfdbfe',color:'#1e40af'},
      {label:'Vent fort (28+ nds)',val:specs.kite_strong,bg:'#fed7aa',color:'#9a3412'}
    ];
    var wg=$i('sk-wind-grid');
    if(wg){
      wg.innerHTML=winds.map(function(w){
        var val=w.val||'Non recommande';
        var isNR=!w.val;
        return'<div style="background:'+(isNR?'#fecaca':w.bg)+';border-radius:12px;padding:12px 8px;text-align:center">'
          +'<div style="font-size:.75em;font-weight:700;color:#1a1a2e">'+w.label+'</div>'
          +'<div style="font-size:1em;font-weight:800;color:'+(isNR?'#991b1b':w.color)+';margin-top:4px">'+val+'</div>'
          +'</div>';
      }).join('');
    }

    /* Conseil perso */
    conseilText=getConseil(currentProfile);
    var ct=$i('sk-conseil-text');
    if(ct)ct.innerHTML=conseilText;

    /* Reset cart */
    cart=[];
    updateCartUI();

    showStep(2);
  });
}

/* ============================================================
   ARTICLES RENDERING
   ============================================================ */
function renderArticleCard(item,hidden){
  var scoreClass=item.score>80?'sk-green':item.score>60?'sk-yellow':'sk-red';
  var initial=(item.vendor||'?')[0];
  var uid=item.category+'_'+item.handle;
  var style=hidden?'display:none':'';
  var html='<div class="sk-article-card" data-handle="'+item.handle+'" data-uid="'+uid+'" data-cat="'+item.category+'" style="cursor:pointer;background:#fff;border-radius:14px;padding:12px;box-shadow:0 2px 8px rgba(0,0,0,.06);transition:all .2s;border:2px solid transparent;position:relative;'+style+'">';
  html+='<div class="sk-article-check" style="position:absolute;top:8px;right:8px;z-index:5" onclick="event.stopPropagation()"><input type="checkbox" data-uid="'+uid+'" title="Ajouter au panier" style="width:22px;height:22px;accent-color:#e67e22;cursor:pointer"></div>';
  html+='<div class="sk-article-thumb" id="sk-thumb-'+uid+'" style="width:100%;height:130px;border-radius:10px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;overflow:hidden;margin-bottom:10px"><span style="font-size:2.2em;font-weight:800;color:#d35400">'+initial+'</span></div>';
  html+='<div class="sk-article-info">';
  html+='<div style="font-size:.82em;font-weight:700;color:#1a1a2e;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">'+item.title+'</div>';
  html+='<div style="font-size:.72em;color:#6b7280;margin-top:2px">'+item.vendor+' \u00B7 '+item.etat+'</div>';
  html+='<div style="font-size:.95em;font-weight:800;color:#d35400;margin-top:2px">'+item.price+' \u20AC</div>';
  if(item.score>=70){
    html+='<div style="margin-top:4px"><div style="height:6px;background:#e5e7eb;border-radius:3px;overflow:hidden"><div style="height:100%;width:'+item.score+'%;background:'+(item.score>80?'#22c55e':'#eab308')+';border-radius:3px"></div></div>';
    html+='<div style="font-size:.65em;font-weight:700;color:'+(item.score>80?'#16a34a':'#ca8a04')+';margin-top:2px">'+item.score+'%</div></div>';
  }
  html+='</div></div>';
  return html;
}

function renderColumn(title,items,max){
  var html='<div class="sk-column" style="flex:1;min-width:280px"><div style="font-family:Staatliches,sans-serif;font-size:1em;letter-spacing:2px;color:#d35400;margin-bottom:10px;text-transform:uppercase">'+title+'</div><div class="sk-col-scroll" style="display:flex;flex-direction:column;gap:8px">';
  items.forEach(function(it,i){html+=renderArticleCard(it,i>=max)});
  html+='</div></div>';
  return html;
}

function renderArticles(kites,boards,bars,profile){
  var max=4;
  var container=$i('sk-articles');
  if(!container)return;
  var html='<div class="sk-columns" style="display:flex;gap:16px;flex-wrap:wrap">';
  if(kites.length>0)html+=renderColumn('Kites',kites,max);
  if(boards.length>0)html+=renderColumn('Planches',boards,max);
  if(bars.length>0)html+=renderColumn('Barres',bars,max);
  html+='</div>';
  container.innerHTML=html;
  loadProductImages();
  /* Click handlers */
  container.querySelectorAll('.sk-article-card').forEach(function(card){
    card.addEventListener('click',function(e){
      if(e.target.closest('.sk-article-check'))return;
      openModal(card.getAttribute('data-handle'));
    });
  });
  container.querySelectorAll('.sk-article-check input').forEach(function(cb){
    cb.addEventListener('change',function(){
      var uid=this.getAttribute('data-uid');
      if(this.checked)addToCart(uid);else removeFromCart(uid);
    });
  });
}

/* ============================================================
   PRODUCT IMAGES (Shopify)
   ============================================================ */
function loadProductImages(){
  document.querySelectorAll('.sim-kite .sk-article-thumb[id]').forEach(function(thumb){
    var card=thumb.closest('.sk-article-card');
    if(!card)return;
    var handle=card.getAttribute('data-handle');
    if(!handle)return;
    if(imgCache[handle]){applyImage(thumb,imgCache[handle]);if(stockCache[handle]===false)markSoldOut(card);return}
    var xhr=new XMLHttpRequest();
    xhr.open('GET','/products/'+handle+'.js',true);
    xhr.onload=function(){
      if(xhr.status!==200)return;
      try{
        var data=JSON.parse(xhr.responseText);
        var img=data.featured_image||(data.images&&data.images[0]);
        if(img){if(img.indexOf('//')===0)img='https:'+img;imgCache[handle]=img;applyImage(thumb,img)}
        if(data.variants&&data.variants[0])variantCache[handle]=data.variants[0].id;
        var available=!!data.available;
        stockCache[handle]=available;
        if(!available)markSoldOut(card);
      }catch(e){}
    };
    xhr.onerror=function(){};
    xhr.send();
  });
}

function markSoldOut(card){
  if(card.classList.contains('sk-sold-out'))return;
  card.classList.add('sk-sold-out');
  card.style.display='none';
  var cb=card.querySelector('input[type=checkbox]');
  if(cb){cb.disabled=true;cb.checked=false}
  var col=card.closest('.sk-col-scroll');
  if(!col)return;
  var reserve=col.querySelector('.sk-article-card[style*="display:none"]:not(.sk-sold-out)');
  if(reserve){
    reserve.style.display='';
    var thumb=reserve.querySelector('.sk-article-thumb[id]');
    if(thumb){
      var handle=reserve.getAttribute('data-handle');
      if(handle&&!imgCache[handle]){
        var xhr=new XMLHttpRequest();
        xhr.open('GET','/products/'+handle+'.js',true);
        xhr.onload=function(){
          if(xhr.status!==200){markSoldOut(reserve);return}
          try{
            var data=JSON.parse(xhr.responseText);
            var img=data.featured_image||(data.images&&data.images[0]);
            if(img){if(img.indexOf('//')===0)img='https:'+img;imgCache[handle]=img;applyImage(thumb,img)}
            else{markSoldOut(reserve);return}
            var available=!!data.available;stockCache[handle]=available;if(!available)markSoldOut(reserve);
          }catch(e){}
        };
        xhr.onerror=function(){markSoldOut(reserve)};xhr.send();
      }else if(imgCache[handle]){
        applyImage(thumb,imgCache[handle]);
        if(stockCache[handle]===false)markSoldOut(reserve);
      }
    }
    reserve.addEventListener('click',function(e){
      if(e.target.closest('.sk-article-check'))return;
      openModal(reserve.getAttribute('data-handle'));
    });
    var newCb=reserve.querySelector('.sk-article-check input');
    if(newCb){newCb.addEventListener('change',function(){var uid=this.getAttribute('data-uid');if(this.checked)addToCart(uid);else removeFromCart(uid)})}
  }
}

function applyImage(thumb,src){
  if(thumb.querySelector('img'))return;
  var span=thumb.querySelector('span');
  var img=document.createElement('img');
  img.src=src;img.loading='lazy';
  img.style.cssText='width:100%;height:100%;object-fit:cover;border-radius:8px';
  img.onload=function(){if(span)span.style.display='none'};
  img.onerror=function(){this.style.display='none'};
  thumb.appendChild(img);
}

/* ============================================================
   PRODUCT MODAL
   ============================================================ */
function openModal(handle){
  /* Create modal overlay if not present */
  var modal=$i('sk-modal');
  if(!modal){
    modal=document.createElement('div');
    modal.id='sk-modal';
    modal.style.cssText='display:none;position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:10000;align-items:center;justify-content:center;padding:16px;overflow-y:auto';
    modal.innerHTML='<div style="background:#fff;border-radius:20px;width:100%;max-width:520px;max-height:90vh;overflow-y:auto;position:relative;margin:auto"><button id="sk-modal-close" style="position:absolute;top:12px;right:12px;width:32px;height:32px;border-radius:50%;background:rgba(0,0,0,.08);border:none;font-size:1.2em;cursor:pointer;z-index:2">&times;</button><div id="sk-modal-content" style="padding:20px"></div></div>';
    document.body.appendChild(modal);
    $i('sk-modal-close').addEventListener('click',closeModal);
    modal.addEventListener('click',function(e){if(e.target===modal)closeModal()});
  }
  var content=$i('sk-modal-content');
  content.innerHTML='<div style="text-align:center;padding:40px;color:#6b7280">Chargement...</div>';
  modal.style.display='flex';
  document.body.style.overflow='hidden';

  if(imgCache['__product_'+handle]){renderModalProduct(imgCache['__product_'+handle],handle);return}
  var xhr=new XMLHttpRequest();
  xhr.open('GET','/products/'+handle+'.json',true);
  xhr.timeout=5000;
  xhr.onload=function(){
    if(xhr.status!==200){showModalFallback(content,handle);return}
    try{var data=JSON.parse(xhr.responseText);imgCache['__product_'+handle]=data.product;renderModalProduct(data.product,handle)}catch(e){showModalFallback(content,handle)}
  };
  xhr.onerror=function(){showModalFallback(content,handle)};
  xhr.ontimeout=function(){showModalFallback(content,handle)};
  xhr.send();
}

function showModalFallback(content,handle){
  content.innerHTML='<div style="padding:40px 24px;text-align:center"><p style="color:#6b7280;margin-bottom:16px;font-size:.9em">Impossible de charger les details du produit.</p><a href="/products/'+handle+'" target="_blank" style="display:inline-block;padding:14px 28px;background:#e67e22;color:#fff;border-radius:14px;font-family:Staatliches,sans-serif;font-size:1em;letter-spacing:2px;text-decoration:none">VOIR SUR LE SHOP</a></div>';
}

function findBestVariant(product,sizeFromSim){
  var variants=product.variants||[];
  if(variants.length<=1)return variants[0]||null;
  if(sizeFromSim){
    var s=String(sizeFromSim);
    var patterns=[
      new RegExp('(^|[/ ])'+s.replace('.','\\.')+'m','i'),
      new RegExp('(^|[/ ])'+s.replace('.','\\.')+'M','i'),
      new RegExp('(^|[/ ])'+s.replace('.','')+'L','i'),
      new RegExp('(^|[/ ])'+s.replace('.','\\.')+'cm','i')
    ];
    for(var i=0;i<variants.length;i++){
      var vt=variants[i].title||'';
      for(var p=0;p<patterns.length;p++){
        if(patterns[p].test(vt))return variants[i];
      }
    }
  }
  return variants[0];
}

function getVariantOptions(product,includeSize){
  var options=product.options||[];
  var variants=product.variants||[];
  if(variants.length<=1||options.length<1)return{html:'',hasOptions:false};
  var extraOpts=[];
  options.forEach(function(opt,idx){
    var name=(opt.name||'').toLowerCase();
    if(!includeSize&&(name.indexOf('taille')>=0||name.indexOf('etat')>=0||name.indexOf('\u00e9tat')>=0||name.indexOf('size')>=0||name.indexOf('ann')>=0))return;
    var vals=opt.values||[];
    if(vals.length>1)extraOpts.push({name:opt.name,position:idx,values:vals});
  });
  if(extraOpts.length===0)return{html:'',hasOptions:false};
  var html='<div style="margin:16px 0">';
  extraOpts.forEach(function(opt){
    html+='<label style="display:block;font-size:.7em;font-weight:700;color:#9ca3af;margin-bottom:4px;text-transform:uppercase">'+opt.name+'</label>';
    html+='<select class="sk-modal-option" data-option-pos="'+opt.position+'" style="width:100%;padding:10px 12px;background:#f8f9fa;border:2px solid #e5e7eb;border-radius:10px;color:#1a1a2e;font-size:.9em;font-weight:600;font-family:Montserrat,sans-serif;margin-bottom:10px">';
    opt.values.forEach(function(v){html+='<option value="'+v+'">'+v+'</option>'});
    html+='</select>';
  });
  html+='</div>';
  return{html:html,hasOptions:true};
}

function renderModalProduct(product,handle){
  var content=$i('sk-modal-content');
  var imgSrc=product.image?product.image.src:'';
  var desc=product.body_html||'';
  var tempDiv=document.createElement('div');tempDiv.innerHTML=desc;
  var cleanDesc=tempDiv.textContent||tempDiv.innerText||'';
  if(cleanDesc.length>400)cleanDesc=cleanDesc.substring(0,400)+'...';

  var simItem=null;
  var allItems=(scoredKites||[]).concat(scoredBoards||[]).concat(scoredBars||[]).concat(scoredPacks||[]);
  for(var si=0;si<allItems.length;si++){if(allItems[si].handle===handle){simItem=allItems[si];break}}
  var recSize=simItem?(simItem.size||simItem.dims||simItem.barSize||null):null;
  var bestVar=findBestVariant(product,recSize);
  var price=bestVar?bestVar.price:(product.variants&&product.variants[0]?product.variants[0].price:'');
  var vendor=product.vendor||'';
  var etat='';var year='';
  if(bestVar){
    var vTitle=bestVar.title||'';
    if(vTitle.indexOf('Neuf')>=0)etat='Neuf';
    else if(vTitle.indexOf('Comme Neuf')>=0)etat='Comme Neuf';
    else if(vTitle.indexOf('Tres Bon')>=0||vTitle.indexOf('Tr\u00E8s Bon')>=0)etat='Tr\u00E8s Bon \u00C9tat';
    else if(vTitle.indexOf('Bon Etat')>=0||vTitle.indexOf('Bon \u00C9tat')>=0)etat='Bon \u00C9tat';
    var ym=vTitle.match(/(20\d{2})/);if(ym)year=ym[1];
  }

  var images=product.images||[];var galleryHtml='';
  if(images.length>1){
    galleryHtml='<div style="display:flex;gap:6px;margin-bottom:16px;overflow-x:auto;padding-bottom:4px">';
    images.slice(0,5).forEach(function(img,i){
      galleryHtml+='<img src="'+img.src+'" style="width:64px;height:64px;object-fit:cover;border-radius:8px;cursor:pointer;border:2px solid '+(i===0?'#e67e22':'transparent')+'" onclick="skModalMainImg(this,\''+img.src+'\')">';
    });
    galleryHtml+='</div>';
  }

  var isPack=(simItem&&simItem.category==='pack');
  var optionsInfo=getVariantOptions(product,isPack);
  var html='';
  html+='<div style="width:100%;height:280px;background:#f3f4f6;border-radius:14px;overflow:hidden;display:flex;align-items:center;justify-content:center;margin-bottom:16px">'+(imgSrc?'<img id="sk-modal-main-img" src="'+imgSrc+'" style="width:100%;height:100%;object-fit:contain">':'<span style="font-size:3em;color:#e67e22">'+(vendor[0]||'?')+'</span>')+'</div>';
  html+='<div style="font-size:.7em;font-weight:700;color:#e67e22;text-transform:uppercase;letter-spacing:1px">'+vendor+'</div>';
  html+='<h2 style="font-family:Staatliches,sans-serif;font-size:1.3em;letter-spacing:1px;color:#1a1a2e;margin:4px 0 8px">'+product.title+'</h2>';
  if(etat||year)html+='<div style="font-size:.8em;color:#6b7280;margin-bottom:8px">'+etat+(year?' \u00B7 '+year:'')+'</div>';
  if(recSize)html+='<div style="display:inline-block;background:#fff7ed;border:1px solid #fed7aa;border-radius:8px;padding:4px 10px;font-size:.75em;font-weight:700;color:#d35400;margin-bottom:8px">Taille recommand\u00e9e : '+recSize+'</div>';
  html+='<div style="font-family:Staatliches,sans-serif;font-size:1.8em;color:#d35400;margin:8px 0" id="sk-modal-price">'+parseFloat(price).toFixed(0)+'\u20AC</div>';
  html+=galleryHtml;
  html+=optionsInfo.html;
  if(cleanDesc)html+='<div style="font-size:.82em;color:#4b5563;line-height:1.6;margin:12px 0">'+cleanDesc+'</div>';
  html+='<button id="sk-modal-add-cart" data-handle="'+handle+'" style="display:block;width:100%;padding:16px;background:linear-gradient(135deg,#e67e22,#d35400);color:#fff;border:none;border-radius:14px;font-family:Staatliches,sans-serif;font-size:1.1em;letter-spacing:2px;cursor:pointer;text-align:center;box-shadow:0 6px 24px rgba(230,126,34,.25);transition:all .2s;margin-top:16px">AJOUTER AU PANIER</button>';
  content.innerHTML=html;

  document.getElementById('sk-modal-add-cart').addEventListener('click',function(){
    var h=this.getAttribute('data-handle');
    var allItems=(scoredKites||[]).concat(scoredBoards||[]).concat(scoredBars||[]).concat(scoredPacks||[]);
    var item=null;for(var i=0;i<allItems.length;i++){if(allItems[i].handle===h){item=allItems[i];break}}
    if(item){var uid=item.category+'_'+item.handle;addToCart(uid);this.textContent='AJOUTE !';this.style.background='#059669';var btn=this;setTimeout(function(){btn.textContent='AJOUTER AU PANIER';btn.style.background='linear-gradient(135deg,#e67e22,#d35400)'},1500)}
  });

  if(optionsInfo.hasOptions){
    content.querySelectorAll('.sk-modal-option').forEach(function(sel){
      sel.addEventListener('change',function(){
        var selectedOpts={};
        content.querySelectorAll('.sk-modal-option').forEach(function(s){selectedOpts[s.getAttribute('data-option-pos')]=s.value});
        var variants=product.variants||[];
        for(var vi=0;vi<variants.length;vi++){
          var vt=variants[vi].title||'';
          var match=true;
          for(var k in selectedOpts){if(vt.indexOf(selectedOpts[k])<0)match=false}
          if(match){
            var priceEl=document.getElementById('sk-modal-price');
            if(priceEl)priceEl.textContent=parseFloat(variants[vi].price).toFixed(0)+'\u20AC';
            product._selectedVariantId=variants[vi].id;
            break;
          }
        }
      });
    });
  }
  if(bestVar)product._selectedVariantId=bestVar.id;
}

window.skModalMainImg=function(el,src){
  var main=document.getElementById('sk-modal-main-img');
  if(main)main.src=src;
  el.parentElement.querySelectorAll('img').forEach(function(s){s.style.borderColor='transparent'});
  el.style.borderColor='#e67e22';
};

function closeModal(){
  var m=$i('sk-modal');
  if(m)m.style.display='none';
  document.body.style.overflow='';
}

/* ============================================================
   MATOS POPUP (fullscreen)
   ============================================================ */
window.openKiteMatosPopup=function(){
  if(!currentProfile||!scoredKites)return;
  var existing=document.getElementById('sk-matos-fullpopup');
  if(existing)existing.remove();

  var overlay=document.createElement('div');
  overlay.id='sk-matos-fullpopup';
  overlay.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.7);z-index:10000;display:flex;align-items:flex-start;justify-content:center;padding:16px;overflow-y:auto';
  overlay.onclick=function(e){if(e.target===overlay){overlay.remove();updateCartUI()}};

  var box=document.createElement('div');
  box.style.cssText='background:#fff;border-radius:20px;width:100%;max-width:960px;max-height:90vh;overflow-y:auto;position:relative;margin:24px 0';

  var responsiveCSS='<style>'
    +'.sk-matos-tabs{display:none;gap:0;margin-bottom:16px;border-radius:12px;overflow:hidden;border:2px solid #e5e7eb}'
    +'.sk-matos-tab{flex:1;padding:12px 8px;text-align:center;font-family:Staatliches,sans-serif;font-size:.9em;letter-spacing:2px;cursor:pointer;background:#f8f9fa;color:#6b7280;border:none;transition:all .2s}'
    +'.sk-matos-tab.sk-tab-active{background:#e67e22;color:#fff}'
    +'@media(max-width:768px){'
    +'.sk-matos-tabs{display:flex}'
    +'#sk-matos-fullpopup .sk-columns{display:block !important}'
    +'#sk-matos-fullpopup .sk-column{display:none;margin-bottom:12px}'
    +'#sk-matos-fullpopup .sk-column.sk-col-visible{display:block}'
    +'#sk-matos-fullpopup{padding:6px !important}'
    +'}'
    +'</style>';

  var header=responsiveCSS+'<div style="background:linear-gradient(135deg,#e67e22,#d35400);padding:28px 28px 20px;border-radius:20px 20px 0 0;position:relative">'
    +'<button id="sk-matos-close-btn" style="position:absolute;top:16px;right:16px;width:36px;height:36px;border-radius:50%;background:rgba(255,255,255,.15);border:none;font-size:1.3em;color:#fff;cursor:pointer">&times;</button>'
    +'<div style="font-family:Staatliches,sans-serif;font-size:.75em;letter-spacing:3px;color:#e67e22;margin-bottom:8px">SELECTION PERSONNALISEE</div>'
    +'<h3 style="font-family:Staatliches,sans-serif;font-size:1.5em;letter-spacing:2px;color:#fff;margin:0">LE MATOS KITE FAIT POUR TOI</h3>'
    +'<p style="color:rgba(255,255,255,.6);font-size:.85em;margin-top:8px">Base sur ton gabarit et ton niveau. Coche les articles pour les ajouter au panier.</p>'
    +'</div>';

  var tabsBar='<div class="sk-matos-tabs" id="sk-matos-tabs">'
    +'<button class="sk-matos-tab sk-tab-active" data-col="0">KITES</button>'
    +'<button class="sk-matos-tab" data-col="1">PLANCHES</button>'
    +'<button class="sk-matos-tab" data-col="2">BARRES</button>'
    +'<button class="sk-matos-tab" data-col="3">PACKS</button>'
    +'</div>';

  var articlesDiv='<div style="padding:20px 24px 80px">'+tabsBar+'<div id="sk-matos-popup-articles"></div></div>';
  var stickyBar='<div id="sk-matos-cart-bar" style="position:sticky;bottom:0;left:0;right:0;background:linear-gradient(135deg,#e67e22,#d35400);color:#fff;padding:14px 24px;display:none;align-items:center;justify-content:space-between;border-radius:0 0 20px 20px;font-family:Montserrat,sans-serif;box-shadow:0 -4px 20px rgba(0,0,0,.15)"><span id="sk-matos-cart-count" style="font-weight:700;font-size:.95em"></span><button id="sk-matos-cart-submit" style="background:#fff;color:#d35400;border:none;border-radius:10px;padding:10px 24px;font-family:Staatliches,sans-serif;font-size:1em;letter-spacing:2px;cursor:pointer;font-weight:700">SELECTIONNER</button></div>';

  box.innerHTML=header+articlesDiv+stickyBar;
  overlay.appendChild(box);
  document.body.appendChild(overlay);

  /* Hide main cart bar while popup open */
  var mainBar=$i('sk-cart-bar');if(mainBar)mainBar.style.display='none';

  document.getElementById('sk-matos-close-btn').addEventListener('click',function(){overlay.remove();updateCartUI()});

  /* Render filtered products — padding 20 items + tri par score desc + filtre bars strict */
  var specs=getKiteSpecs(currentProfile.poids);
  function padToN(filtered,fullList,rawList,cat,n){
    var used={};var out=[];
    filtered.forEach(function(x){if(!used[x.handle]){used[x.handle]=1;out.push(x)}});
    fullList.forEach(function(x){if(out.length<n&&!used[x.handle]){used[x.handle]=1;out.push(x)}});
    if(out.length<n&&rawList){
      var ideal=0;
      if(cat==='kite'){var km=(specs.kite_medium||'').match(/[\d.]+/);if(km)ideal=parseFloat(km[0])}
      else if(cat==='board_kite'){var bm=(specs.board||'').match(/(\d+)x/);if(bm)ideal=parseInt(bm[1])}
      var keyFn=cat==='kite'?'size':cat==='board_kite'?'length':'';
      var extras=rawList.filter(function(x){return!used[x.handle]}).map(function(x){
        return Object.assign({},x,{score:45,category:cat,reason:'Option complementaire',rawScore:0});
      });
      if(keyFn)extras.sort(function(a,b){return Math.abs((a[keyFn]||0)-ideal)-Math.abs((b[keyFn]||0)-ideal)});
      extras.forEach(function(x){if(out.length<n&&!used[x.handle]){used[x.handle]=1;out.push(x)}});
    }
    return out.slice(0,n);
  }
  var fKites=padToN(scoredKites.slice(),scoredKites,KITES,'kite',20).filter(function(k){return!k.size||k.size>=5});
  var fBoards=padToN(scoredBoards.slice(),scoredBoards,BOARDS_KITE,'board_kite',20);
  /* Filtre BARS strict : uniquement Kite Attitude / Totem Vario */
  var fBars=scoredBars.filter(function(b){var v=(b.vendor||'').toLowerCase();return v.indexOf('kite attitude')>=0||v.indexOf('totem')>=0});
  if(fBars.length<5){
    var rawKA=BARS.filter(function(b){var v=(b.vendor||'').toLowerCase();return(v.indexOf('kite attitude')>=0||v.indexOf('totem')>=0)&&!fBars.some(function(x){return x.handle===b.handle})});
    rawKA.forEach(function(b){fBars.push(Object.assign({},b,{score:80,category:'bar',reason:'Barre universelle recommandee',rawScore:0}))});
  }
  /* Tri par score descendant */
  function sortByScore(a,b){return(b.score||0)-(a.score||0)}
  fKites.sort(sortByScore);fBoards.sort(sortByScore);fBars.sort(sortByScore);
  var max=5;
  var html='<div class="sk-columns" style="display:flex;gap:16px;flex-wrap:wrap">';
  if(fKites.length>0)html+=renderColumn('Kites',fKites,max);
  if(fBoards.length>0)html+=renderColumn('Planches',fBoards,max);
  if(fBars.length>0)html+=renderColumn('Barres',fBars,max);
  html+='<div class="sk-column" id="sk-matos-packs-col" style="flex:1;min-width:280px"><div style="font-family:Staatliches,sans-serif;font-size:1em;letter-spacing:2px;color:#d35400;margin-bottom:10px;text-transform:uppercase">Packs complets</div><div class="sk-col-scroll" id="sk-matos-packs-scroll" style="display:flex;flex-direction:column;gap:8px"><div style="padding:16px 8px;text-align:center;font-size:.8em;color:#9ca3af">Chargement des packs...</div></div></div>';
  html+='</div>';
  document.getElementById('sk-matos-popup-articles').innerHTML=html;
  /* Fetch packs kite filtre par budget */
  (function loadPacks(){
    var budget=currentProfile.budget||'moyen';
    function priceMatchBudget(priceEur){
      if(budget==='petit')return priceEur<=1500;
      if(budget==='moyen')return priceEur<=2500;
      if(budget==='confort')return priceEur>=2500&&priceEur<=4000;
      if(budget==='premium')return priceEur>=2500;
      return true;
    }
    var recKiteSize=0;var km=(specs.kite_medium||'').match(/[\d.]+/);if(km)recKiteSize=parseFloat(km[0]);
    function pickPackVariant(variants){
      if(!variants||variants.length===0)return null;
      if(variants.length===1)return variants[0];
      for(var i=0;i<variants.length;i++){
        var t=variants[i].title||'';var m=t.match(/(\d+(?:\.\d+)?)\s*m/i);
        if(m&&Math.abs(parseFloat(m[1])-recKiteSize)<=1)return variants[i];
      }
      var best=variants[0],bestDiff=Infinity;
      variants.forEach(function(v){
        var m2=(v.title||'').match(/(\d+(?:\.\d+)?)\s*m/i);
        if(m2){var d=Math.abs(parseFloat(m2[1])-recKiteSize);if(d<bestDiff){bestDiff=d;best=v}}
      });
      return best;
    }
    var xhr=new XMLHttpRequest();
    xhr.open('GET','/collections/pack-kitesurf/products.json?limit=50',true);
    xhr.timeout=6000;
    xhr.onload=function(){
      var scroll=document.getElementById('sk-matos-packs-scroll');if(!scroll)return;
      try{
        var data=JSON.parse(xhr.responseText);var prods=data.products||[];
        scoredPacks=[];
        prods.forEach(function(p){
          var v=(p.variants&&p.variants[0])||{};
          var priceEur=parseFloat(v.price||0);
          var img='';if(p.images&&p.images[0])img=p.images[0].src||'';
          if(img&&img.indexOf('//')===0)img='https:'+img;
          var available=(v.available!==false);
          if(!priceMatchBudget(priceEur)||!available)return;
          if(img)imgCache[p.handle]=img;
          var picked=pickPackVariant(p.variants||[]);
          if(picked&&picked.id)variantCache[p.handle]=picked.id;
          else if(v.id)variantCache[p.handle]=v.id;
          var cachedProd={id:p.id,title:p.title,vendor:p.vendor,handle:p.handle,body_html:p.body_html||'',image:{src:img},images:(p.images||[]).map(function(i){return{src:i.src}}),options:p.options||[],variants:p.variants||[]};
          if(picked&&picked.id)cachedProd._selectedVariantId=picked.id;
          imgCache['__product_'+p.handle]=cachedProd;
          scoredPacks.push({title:p.title,vendor:p.vendor||'The Ridery',price:Math.round(priceEur),handle:p.handle,category:'pack',score:95,etat:'Neuf',year:2026,reason:'Pack complet dans ton budget'});
        });
        scoredPacks.sort(function(a,b){return a.price-b.price});
        if(scoredPacks.length===0){
          scroll.innerHTML='<div style="padding:16px 8px;text-align:center;font-size:.75em;color:#9ca3af;line-height:1.5">Aucun pack dans cette gamme de budget.<br><a href="/collections/pack-kitesurf" target="_blank" style="color:#e67e22;text-decoration:underline">Voir tous les packs</a></div>';
          return;
        }
        var packsHtml='';
        scoredPacks.slice(0,8).forEach(function(p,i){packsHtml+=renderArticleCard(p,i>=5)});
        scroll.innerHTML=packsHtml;
        scroll.querySelectorAll('.sk-article-card').forEach(function(card){
          card.addEventListener('click',function(e){if(e.target.closest('.sk-article-check'))return;openModal(card.getAttribute('data-handle'));var m=$i('sk-modal');if(m)m.style.zIndex='10001';});
        });
        scroll.querySelectorAll('.sk-article-check input').forEach(function(cb){
          cb.addEventListener('change',function(e){
            e.stopPropagation();e.stopImmediatePropagation();
            var uid=this.getAttribute('data-uid');var card=this.closest('.sk-article-card');
            if(this.checked){if(popupSelected.indexOf(uid)<0)popupSelected.push(uid);if(card){card.style.outline='3px solid #e67e22';card.style.boxShadow='0 0 0 3px rgba(230,126,34,.2)'}}
            else{var idx=popupSelected.indexOf(uid);if(idx>=0)popupSelected.splice(idx,1);if(card){card.style.outline='none';card.style.boxShadow=''}}
            updatePopupBar();
          });
        });
        scroll.querySelectorAll('.sk-article-thumb[id]').forEach(function(thumb){
          var card=thumb.closest('.sk-article-card');if(!card)return;
          var handle=card.getAttribute('data-handle');if(!handle)return;
          if(imgCache[handle])applyImage(thumb,imgCache[handle]);
        });
      }catch(e){
        scroll.innerHTML='<div style="padding:16px 8px;text-align:center;font-size:.75em;color:#9ca3af">Impossible de charger les packs.<br><a href="/collections/pack-kitesurf" target="_blank" style="color:#e67e22;text-decoration:underline">Voir tous les packs</a></div>';
      }
    };
    xhr.onerror=xhr.ontimeout=function(){
      var scroll=document.getElementById('sk-matos-packs-scroll');if(!scroll)return;
      scroll.innerHTML='<div style="padding:16px 8px;text-align:center;font-size:.75em;color:#9ca3af">Impossible de charger les packs.<br><a href="/collections/pack-kitesurf" target="_blank" style="color:#e67e22;text-decoration:underline">Voir tous les packs</a></div>';
    };
    xhr.send();
  })();

  /* Mobile tabs logic */
  (function(){
    var cols=box.querySelectorAll('.sk-columns .sk-column');
    var tabs=box.querySelectorAll('.sk-matos-tab');
    if(cols.length>0&&window.innerWidth<=768){
      cols[0].classList.add('sk-col-visible');
    }
    tabs.forEach(function(tab){
      tab.addEventListener('click',function(){
        tabs.forEach(function(t){t.classList.remove('sk-tab-active')});
        tab.classList.add('sk-tab-active');
        var idx=parseInt(tab.getAttribute('data-col'));
        cols.forEach(function(c,i){
          if(i===idx)c.classList.add('sk-col-visible');
          else c.classList.remove('sk-col-visible');
        });
      });
    });
  })();

  /* Load images in popup */
  box.querySelectorAll('.sk-article-thumb[id]').forEach(function(thumb){
    var card=thumb.closest('.sk-article-card');if(!card)return;
    var handle=card.getAttribute('data-handle');if(!handle)return;
    if(imgCache[handle]){applyImage(thumb,imgCache[handle]);if(stockCache[handle]===false)markSoldOut(card);return}
    var xhr=new XMLHttpRequest();
    xhr.open('GET','/products/'+handle+'.js',true);
    xhr.onload=function(){
      if(xhr.status!==200)return;
      try{var data=JSON.parse(xhr.responseText);var img=data.featured_image||(data.images&&data.images[0]);if(img){if(img.indexOf('//')===0)img='https:'+img;imgCache[handle]=img;applyImage(thumb,img)}var available=!!data.available;stockCache[handle]=available;if(!available)markSoldOut(card)}catch(e){}
    };
    xhr.onerror=function(){};xhr.send();
  });

  /* Popup selection */
  var popupSelected=[];
  function updatePopupBar(){
    var bar=document.getElementById('sk-matos-cart-bar');
    var countEl=document.getElementById('sk-matos-cart-count');
    if(popupSelected.length===0){bar.style.display='none';return}
    bar.style.display='flex';
    countEl.textContent=popupSelected.length+' article'+(popupSelected.length>1?'s':'')+' selectionne'+(popupSelected.length>1?'s':'');
  }

  box.querySelectorAll('.sk-article-card').forEach(function(card){
    card.addEventListener('click',function(e){
      if(e.target.closest('.sk-article-check'))return;
      openModal(card.getAttribute('data-handle'));
      var m=$i('sk-modal');if(m)m.style.zIndex='10001';
    });
  });

  box.querySelectorAll('.sk-article-check input').forEach(function(cb){
    cb.addEventListener('change',function(e){
      e.stopPropagation();e.stopImmediatePropagation();
      var uid=this.getAttribute('data-uid');
      var card=this.closest('.sk-article-card');
      if(this.checked){
        if(popupSelected.indexOf(uid)<0)popupSelected.push(uid);
        if(card){card.style.outline='3px solid #e67e22';card.style.boxShadow='0 0 0 3px rgba(230,126,34,.2)'}
      }else{
        var idx=popupSelected.indexOf(uid);if(idx>=0)popupSelected.splice(idx,1);
        if(card){card.style.outline='none';card.style.boxShadow=''}
      }
      updatePopupBar();
    });
  });

  document.getElementById('sk-matos-cart-submit').addEventListener('click',function(){
    if(popupSelected.length===0)return;
    popupSelected.forEach(function(uid){addToCart(uid)});
    overlay.remove();
    updateCartUI();
  });
};

/* ============================================================
   CART
   ============================================================ */
function findProduct(uid){
  var parts=uid.split('_');var cat=parts[0];var handle=parts.slice(1).join('_');
  var list=cat==='kite'?scoredKites:cat==='board_kite'||cat==='board'?scoredBoards:cat==='bar'?scoredBars:cat==='pack'?scoredPacks:[];
  return list.find(function(p){return p.handle===handle})||null;
}

function addToCart(uid){
  if(cart.some(function(c){return c.uid===uid}))return;
  var p=findProduct(uid);if(!p)return;
  cart=cart.concat([{uid:uid,title:p.title,price:p.price,handle:p.handle,category:p.category}]);
  updateCartUI();
}

function removeFromCart(uid){
  cart=cart.filter(function(c){return c.uid!==uid});
  var cb=document.querySelector('.sim-kite .sk-article-check input[data-uid="'+uid+'"]');
  if(cb)cb.checked=false;
  updateCartUI();
}

function updateCartUI(){
  var bar=$i('sk-cart-bar');
  if(!bar)return;
  if(cart.length===0){bar.style.display='none';return}
  if(document.getElementById('sk-matos-fullpopup')){bar.style.display='none';return}
  bar.style.display='flex';
  bar.style.cssText='position:sticky;bottom:0;left:0;right:0;background:linear-gradient(135deg,#e67e22,#d35400);color:#fff;padding:14px 24px;display:flex;align-items:center;justify-content:space-between;border-radius:16px;font-family:Montserrat,sans-serif;box-shadow:0 -4px 20px rgba(0,0,0,.15);margin-top:16px;z-index:999';
  var total=cart.reduce(function(s,c){return s+c.price},0);
  var summary=$i('sk-cart-summary');
  if(summary){
    summary.style.cssText='display:flex;align-items:center;justify-content:space-between;width:100%;gap:12px';
    summary.innerHTML='<span style="font-weight:700;font-size:.9em">PANIER : '+cart.length+' ARTICLE'+(cart.length>1?'S':'')+'</span>'
      +'<span style="display:flex;align-items:center;gap:12px"><span style="font-weight:700;font-size:.95em">'+total+' &#8364;</span>'
      +'<button id="sk-cart-go-btn" style="background:#fff;color:#d35400;border:none;border-radius:10px;padding:10px 20px;font-family:Staatliches,sans-serif;font-size:.9em;letter-spacing:2px;cursor:pointer;font-weight:700;white-space:nowrap">AJOUTER AU PANIER</button></span>';
    document.getElementById('sk-cart-go-btn').addEventListener('click',function(e){e.stopPropagation();addCartToShopify()});
  }
  var expand=$i('sk-cart-expand');
  var itemsEl=$i('sk-cart-items');
  if(itemsEl){
    var itemsHtml='';
    cart.forEach(function(c){
      itemsHtml+='<div style="display:flex;align-items:center;justify-content:space-between;padding:8px 0;border-bottom:1px solid rgba(255,255,255,.15);font-size:.85em"><span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+c.title+'</span><span style="margin:0 10px;font-weight:700">'+c.price+'&#8364;</span><button data-uid="'+c.uid+'" style="background:none;border:none;color:#fff;font-size:1.2em;cursor:pointer;padding:0 4px">&times;</button></div>';
    });
    itemsEl.innerHTML=itemsHtml;
    itemsEl.querySelectorAll('button[data-uid]').forEach(function(btn){
      btn.addEventListener('click',function(e){e.stopPropagation();removeFromCart(this.getAttribute('data-uid'))});
    });
  }
}

if($i('sk-cart-summary')){
  $i('sk-cart-summary').addEventListener('click',function(){
    cartExpanded=!cartExpanded;
    var expand=$i('sk-cart-expand');
    if(expand)expand.style.display=cartExpanded?'block':'none';
  });
}

/* ============================================================
   SHOPIFY CART INTEGRATION
   ============================================================ */
function findBestVariantForCart(product,handle){
  if(product._selectedVariantId)return product._selectedVariantId;
  var variants=product.variants||[];
  if(variants.length<=1)return variants[0]?variants[0].id:null;
  var simItem=null;
  var allItems=(scoredKites||[]).concat(scoredBoards||[]).concat(scoredBars||[]).concat(scoredPacks||[]);
  for(var si=0;si<allItems.length;si++){if(allItems[si].handle===handle){simItem=allItems[si];break}}
  if(simItem){
    var recSize=simItem.size||simItem.dims||simItem.barSize||null;
    if(recSize){var best=findBestVariant(product,recSize);if(best)return best.id}
  }
  return variants[0].id;
}

function addCartToShopify(){
  if(cart.length===0){alert('Selectionne au moins un article en cochant la case.');return}
  var loaded=0;var products={};
  var fetchItems=cart.slice();
  fetchItems.forEach(function(c){
    var h=c.handle;
    if(imgCache['__product_'+h]&&imgCache['__product_'+h].variants){
      products[h]=imgCache['__product_'+h];loaded++;
      if(loaded===fetchItems.length)finalize();
    }else{
      var xhr=new XMLHttpRequest();
      xhr.open('GET','/products/'+h+'.js',true);
      xhr.onload=function(){loaded++;try{var d=JSON.parse(xhr.responseText);if(d.variants){imgCache['__product_'+h]=d;products[h]=d}}catch(e){}if(loaded===fetchItems.length)finalize()};
      xhr.onerror=function(){loaded++;if(loaded===fetchItems.length)finalize()};
      xhr.send();
    }
  });
  function finalize(){
    var allItems=[];
    fetchItems.forEach(function(c){
      var p=products[c.handle];if(!p)return;
      var vid=findBestVariantForCart(p,c.handle);
      if(vid)allItems.push({id:vid,quantity:1});
    });
    submitCart(allItems);
  }
}

function submitCart(items){
  if(items.length===0){alert('Selectionne au moins un article.');return}
  var xhr=new XMLHttpRequest();
  xhr.open('POST','/cart/add.js',true);
  xhr.setRequestHeader('Content-Type','application/json');
  xhr.onload=function(){
    cart=[];updateCartUI();
    window.location.href='/cart';
  };
  xhr.onerror=function(){
    window.location.href='/cart/'+items.map(function(it){return it.id+':'+it.quantity}).join(',');
  };
  xhr.send(JSON.stringify({items:items}));
}

function refreshCartDrawer(){
  setTimeout(function(){
    try{
      var xc=new XMLHttpRequest();xc.open('GET','/cart.js',true);
      xc.onload=function(){
        try{
          var c=JSON.parse(xc.responseText);
          document.querySelectorAll('.cart-count-badge,.cart-count,.js-cart-count,[data-cart-count]').forEach(function(b){b.textContent=c.item_count});
        }catch(ex){}
      };xc.send();
    }catch(ex){}
    try{
      var xs=new XMLHttpRequest();xs.open('GET','/?sections=cart-drawer,cart-icon-bubble',true);
      xs.onload=function(){
        try{
          var sections=JSON.parse(xs.responseText);
          for(var key in sections){
            if(!sections.hasOwnProperty(key))continue;
            var el=document.getElementById('shopify-section-'+key);
            if(el&&sections[key]){
              var tmp=document.createElement('div');tmp.innerHTML=sections[key];
              el.innerHTML=tmp.firstElementChild?tmp.firstElementChild.innerHTML:tmp.innerHTML;
            }
          }
        }catch(ex){}
      };xs.send();
    }catch(ex){}
  },500);
}

/* ============================================================
   DEVIS POPUP
   ============================================================ */
(function(){
  var submitBtn=$i('sk-devis-submit');
  if(!submitBtn)return;
  submitBtn.addEventListener('click',function(e){
    e.preventDefault();
    var prenom=($i('sk-popup-prenom')||{}).value||'';
    var nom=($i('sk-popup-nom')||{}).value||'';
    var email=($i('sk-popup-email')||{}).value||'';
    var tel=($i('sk-popup-tel')||{}).value||'';
    var message=($i('sk-popup-message')||{}).value||'';
    prenom=prenom.trim();nom=nom.trim();email=email.trim();tel=tel.trim();
    if(!prenom||!nom||!email){alert('Merci de renseigner ton prenom, nom et email.');return}
    var freqEl=$i('sk-devis-freq');var freq=freqEl?(freqEl.value||'').trim():'';
    if(!freq){alert('Merci d\'indiquer ta frequence de navigation.');if(freqEl)freqEl.focus();return}

    var specs=currentProfile?getKiteSpecs(currentProfile.poids):null;
    /* Apply debutant override on specs for email too */
    if(specs&&currentProfile&&currentProfile.level==='debutant'){
      specs=Object.assign({},specs,{kite_strong:null});
    }
    var LEVEL_LABELS={debutant:'debutant',intermediaire:'intermediaire',confirme:'confirme'};
    var now=new Date();
    var dateStr=now.toLocaleDateString('fr-FR',{day:'2-digit',month:'2-digit',year:'numeric'})+' '+now.toLocaleTimeString('fr-FR',{hour:'2-digit',minute:'2-digit',second:'2-digit'});

    /* Pre-fetch images for articles before sending */
    var allHandles=[];
    scoredKites.slice(0,5).forEach(function(k){if(!imgCache[k.handle])allHandles.push(k.handle)});
    scoredBoards.slice(0,5).forEach(function(b){if(!imgCache[b.handle])allHandles.push(b.handle)});
    scoredBars.slice(0,5).forEach(function(b){if(!imgCache[b.handle])allHandles.push(b.handle)});

    function buildAndSendKlaviyo(){
      var payload={
        simulateur:'kite-v1',
        prenom:prenom,nom:nom,email:email,tel:tel,
        poids:currentProfile?currentProfile.poids+'kg':'',
        taille:currentProfile?currentProfile.taille+'cm':'',
        age:currentProfile?currentProfile.age+' ans':'',
        niveau:currentProfile?(LEVEL_LABELS[currentProfile.level]||currentProfile.level):'',
        spot:currentProfile?getSpotDisplayName(currentProfile.spot):'',
        spot_code:currentProfile?currentProfile.spot:'',
        budget:currentProfile?currentProfile.budget:'',
        setup_quiver:specs?[specs.kite_light,specs.kite_medium,specs.kite_strong].filter(Boolean).join(' / '):'',
        setup_board:specs?specs.board.split('/')[0].trim()+' cm':'',
        setup_bar:'Barre universelle Kite Attitude',
        kite_light:specs?(specs.kite_light||'Non recommande'):'--',
        kite_medium:specs?(specs.kite_medium||'Non recommande'):'--',
        kite_strong:specs?(specs.kite_strong||'Non recommande'):'--',
        conseil:(function(){if(!conseilText)return'';var tmp=document.createElement('div');tmp.innerHTML=conseilText;tmp.querySelectorAll('button,a').forEach(function(el){el.remove()});return(tmp.textContent||tmp.innerText||'').replace(/\s+/g,' ').trim()})(),
        articles_kite_detail:scoredKites.slice(0,5).map(function(k){return{title:k.title,price:k.price,handle:k.handle,score:k.score,vendor:k.vendor,etat:k.etat,url:'https://theridery.com/products/'+k.handle,image:imgCache[k.handle]||'',variant_id:variantCache[k.handle]||''}}),
        articles_board_detail:scoredBoards.slice(0,5).map(function(b){return{title:b.title,price:b.price,handle:b.handle,score:b.score,vendor:b.vendor,etat:b.etat,url:'https://theridery.com/products/'+b.handle,image:imgCache[b.handle]||'',variant_id:variantCache[b.handle]||''}}),
        articles_bar_detail:scoredBars.slice(0,5).map(function(b){return{title:b.title,price:b.price,handle:b.handle,score:b.score,vendor:b.vendor,etat:b.etat,url:'https://theridery.com/products/'+b.handle,image:imgCache[b.handle]||'',variant_id:variantCache[b.handle]||''}}),
        date:dateStr
      };
      var klavData=JSON.stringify({
        token:'R2W6jR',
        event:'devis_simulateur',
        customer_properties:{'$email':email,'$first_name':prenom,'$last_name':nom,'$phone_number':tel||''},
        properties:payload
      });
      var klavPixel=new Image();
      klavPixel.src='https://a.klaviyo.com/api/track?data='+btoa(unescape(encodeURIComponent(klavData)));
    }

    if(allHandles.length===0){buildAndSendKlaviyo()}
    else{
      var fetched=0;
      allHandles.forEach(function(h){
        var xhr=new XMLHttpRequest();xhr.open('GET','/products/'+h+'.js',true);xhr.timeout=3000;
        xhr.onload=function(){fetched++;try{var d=JSON.parse(xhr.responseText);var img=d.featured_image||(d.images&&d.images[0]);if(img){if(img.indexOf('//')===0)img='https:'+img;imgCache[h]=img}if(d.variants&&d.variants[0])variantCache[h]=d.variants[0].id}catch(e){}if(fetched>=allHandles.length)buildAndSendKlaviyo()};
        xhr.onerror=xhr.ontimeout=function(){fetched++;if(fetched>=allHandles.length)buildAndSendKlaviyo()};
        xhr.send();
      });
    }

    /* Show success in popup */
    var popup=$i('sk-popup-devis');
    if(popup){
      var inner=popup.querySelector('div')||popup;
      inner.innerHTML='<div style="text-align:center;padding:48px 24px"><div style="font-size:3em;margin-bottom:16px">&#10003;</div><h3 style="font-family:Staatliches,sans-serif;font-size:1.5em;letter-spacing:2px;color:#d35400;margin-bottom:12px">MERCI '+prenom.toUpperCase()+' !</h3><p style="color:#4b5563;font-size:.95em;line-height:1.6">Ton devis personnalise a ete envoye a <b>'+email+'</b>.<br>On revient vers toi tres vite.</p><button onclick="document.getElementById(\'sk-popup-devis\').style.display=\'none\'" style="margin-top:24px;padding:14px 32px;background:#e67e22;color:#fff;border:none;border-radius:12px;font-family:Staatliches,sans-serif;font-size:1.05em;letter-spacing:2px;cursor:pointer">FERMER</button></div>';
    }
  });
})();

/* ============================================================
   RESTART
   ============================================================ */
function resetAll(){
  var fields=['sk-poids','sk-taille','sk-age','sk-popup-prenom','sk-popup-nom','sk-popup-email','sk-popup-tel','sk-popup-message'];
  fields.forEach(function(id){var el=$i(id);if(el)el.value=''});
  selectedLevel=null;currentProfile=null;
  cart=[];updateCartUI();
  scoredKites=[];scoredBoards=[];scoredBars=[];
  var lo=$i('sk-level-options');
  if(lo)lo.querySelectorAll('.sk-option-card').forEach(function(c){c.classList.remove('selected')});
  showStep(1);
}

document.querySelectorAll('[id^="sk-restart-link"]').forEach(function(link){
  link.addEventListener('click',function(e){
    e.preventDefault();
    resetAll();
  });
});

/* ============================================================
   SPOT DISPLAY NAME
   ============================================================ */
function getSpotDisplayName(spotCode){
  var names={marseille:'Marseille / Cote Bleue',hyeres:'Almanarre / Hyeres',montpellier:'Montpellier / Sete',leucate:'Leucate / Gruissan',nice:'Nice / Cannes',biarritz:'Biarritz / Pays Basque',paris:'Paris / IDF',bonifacio:'Corse',atlantique:'Atlantique',autre:'Autre'};
  return names[spotCode]||spotCode;
}

/* ============================================================
   FIX SELECTS STYLING
   ============================================================ */
function fixSelects(){
  document.querySelectorAll('.sim-kite select').forEach(function(sel){
    sel.style.setProperty('background','#f8f9fa','important');
    sel.style.setProperty('background-image','none','important');
    sel.style.setProperty('background-color','#f8f9fa','important');
    sel.style.setProperty('-webkit-appearance','none','important');
    sel.style.setProperty('-moz-appearance','none','important');
    sel.style.setProperty('appearance','none','important');
    sel.style.setProperty('border','2px solid #e5e7eb','important');
    sel.style.setProperty('border-radius','12px','important');
    sel.style.setProperty('padding','12px 14px','important');
    sel.style.setProperty('color','#1a1a2e','important');
    sel.style.setProperty('font-size','.95em','important');
    sel.style.setProperty('font-weight','600','important');
    sel.style.setProperty('font-family','Montserrat,sans-serif','important');
    sel.style.setProperty('width','100%','important');
  });
}
fixSelects();
setTimeout(fixSelects,500);
setTimeout(fixSelects,1500);

})();
